import { Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[autofocus]',
})
export class AutofocusDirective {
  observer?: IntersectionObserver
  @Input() autofocus = true

  constructor (
    private element: ElementRef<HTMLElement>,
  ) { }

  ngAfterViewInit () {
    if (this.autofocus) {
      this.element.nativeElement.focus()
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(() => {
        if (this.autofocus) {
          this.element.nativeElement.focus()
        }
      }, {
        root: document.body,
        rootMargin: '0px',
        threshold: 1.0,
      })
    }

    this.observer?.observe(this.element.nativeElement)
  }

  ngOnDestroy () {
    this.observer?.disconnect()
  }
}
